import type { TFunction } from 'i18next';
import convertToYup from 'json-schema-yup-transformer';
import React from 'react';

import { generateSchema } from 'app/pages/Registration/validation';
import baseForm from 'assets/baseForm';
import { pathFromString } from 'app/pages/Registration/utils';
import Components from 'app/components';

import { BaseForm, FormContent, Path } from './interfaces';

export interface Step {
  info: string;
  path: Path;
  content: React.ReactElement;
  validation: ReturnType<typeof convertToYup>;
}

type Props = {
  children?: never;
  content: FormContent[];
  path: Path;
  base: BaseForm[];
};

const StepContent: React.FC<Props> = ({ base, content, path }) => (
  <>
    {content.map((props) => {
      const { type, label } = props;
      switch (type) {
        case 'boolean':
          return <Components.CheckBox {...props} key={label} path={path} />;
        case 'countrySelect':
          return <Components.RegionSelect {...props} key={label} path={path} />;
        case 'pricePlan':
          return <Components.PricePlan {...props} key={label} path={path} />;
        case 'confirm':
          return <Components.Confirm key={label} path={path} base={base} />;
        case 'number':
        case 'tel':
        case 'string':
        case 'email':
        default:
          return <Components.TextField {...props} key={label} path={path} />;
      }
    })}
  </>
);

const steps = (form = baseForm, t: TFunction = (e: string) => e): Step[] =>
  form.map((view) => ({
    path: view.path,
    info: t(`registration.view.${view.path}`),
    content: (
      <StepContent content={view.content} path={view.path} base={form} />
    ),
    validation: generateSchema(view, t),
  }));

export const getPath = (i: number): string => {
  const { path } = steps()[i];
  return pathFromString(path);
};
export const getPathIndex = (pathname: string): number => {
  const pathElements = pathname.split('/');
  const path = pathElements[pathElements.length - 1];
  return steps().findIndex((el) => el.path === path);
};

export default steps;
